<template>
    <div style="background: white; width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 10px 20px;">
        <div style="width: auto; display: flex; align-items: center;">
            <v-avatar class="v-company-logo mr-4 pa-2 hidden-sm-only" size="35px" v-if="company.logo">
                <img :src="companyLogo" alt="Logo" height="40px">
            </v-avatar>

            <v-toolbar-title class="ml-0 hidden-sm-only v-toolbar-title">
                <div>{{company.name}}</div>
                <div style="font-size: 14px">Simulador de Crédito</div>
            </v-toolbar-title>
        </div>

        <div style="display: flex; align-items: center; justify-content: center;">
            <div style="width: auto; display: flex;">
                <a-text-field hide-details background-color="#EFEFEF" :disabled="canSearch" :class="{'search-style': true}" browser-autocomplete="nope" clearable light label="Nome/CPF/CNPJ/Fone" v-model="searchText" v-on:keyup.enter="search()">
                </a-text-field>
            </div>

            <div style="width: auto; display: flex; align-items: center; justify-content: center;">
                <div class="divider"></div>
                <div>
                    <v-btn @click="$router.push('/dashboard')" icon>
                        <v-icon>close</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchText: "",
        }
    },

    props: {
        userName: {
            type: String,
            required: true,
        },
        userAvatar: {
            type: String,
            requried: true
        },
        userOptions: {
            type: Array,
            required: true
        },
        company: {
            type: Object,
            required: true
        },
        canSearch: {
            type: Boolean,
            required: true
        },
        searchClientList: {
            type: Function,
            required: true
        },
    },

    computed: {
        companyLogo() {
			let logo = this.company.logo;
			let media;
			if (logo) {
				media = this.$config.imageUri(this.company.logo, 'logo');
			}

			return media;
		},
    },

    methods: {
        async search() {
            await this.searchClientList(this.searchText);
            this.searchText = "";
        },
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Prospection/Header.vue